import React from "react";
import TextInfo from "@/bit/components/next13.components.text";
import Button from "@/bit/components/next13.components.button";

function LegalModalLink({ button, skeletonClassName, text, alias, onClick }) {
  if (!button && !button?.label) return null;

  const taggingInfoLegalModal = {
    componentName: "buy-box",
    componentVariation: "all",
    componentContent: button.label ? button.label : "",
    componentProduct: alias,
    eventType: "click",
  };

  const legalClassNames = text ? "with-pre-legals" : "";

  const onClickHandler = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <>
      <hr className="separator" />
      <div
        className={`skeleton skeleton-buybox skeleton-legals ${skeletonClassName} ${
          text ? " with-pre-legals" : ""
        }`}
      >
        <div className={`buy-box-legal ${legalClassNames}`}>
          {text && (
            <TextInfo {...text} className="pre-legals" cyData="BuyBox Text-4" />
          )}

          <Button
            {...button}
            onClick={onClickHandler}
            className="legal-button"
            taggingInfo={taggingInfoLegalModal}
            cyData="BuyBox Button-2"
          />
        </div>
      </div>
    </>
  );
}

export default LegalModalLink;
